export const STEP_MAP = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
};

export const STEP_LIST = [
    { value: STEP_MAP.ZERO, label: '基本信息' },
    { value: STEP_MAP.ONE, label: '资质及证照信息' },
    { value: STEP_MAP.TWO, label: '供货能力' },
    { value: STEP_MAP.THREE, label: '供货范围' },
    { value: STEP_MAP.FOUR, label: '主营商品' },
];

export const AJAX_ACTION = `${window.location.origin}/api/upload/picture.ajax`;


// source："来源：1.采购推荐 2.线下活动 3.线索 4.商家自主提报 5.未知"
// entryPoint："填写入口：1.美团app 2.小象app 3.二维码 4.vsspc、 5.微信小程序 、6.小象超市官网、7.未知（历史数据）、8.芥末"
// eventName：活动名称
// eventDate：活动日期
export const SOURCE_TYPE = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
};
export const ENTRY_POINT = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    SEVEN: 7,
    EIGHT: 8,
};

export function isValidSource(source) {
    return Object.values(SOURCE_TYPE).includes(Number(source));
}
export function isValidEntryPoint(entryPoint) {
    return Object.values(ENTRY_POINT).includes(Number(entryPoint));
}
export function saveSourceParamsToLocalStorage(
    source = '',
    entryPoint = '',
    eventName = '',
    eventDate = '',
) {
    const obj = {
        source: isValidSource(source) ? source : '',
        entryPoint: isValidEntryPoint(entryPoint) ? entryPoint : '',
        eventName: eventName ? decodeURIComponent(eventName) : '',
        eventDate,
    };
    // 将来源参数保存到localStorage
    if (obj.source || obj.entryPoint || obj.eventName || obj.eventDate) {
        localStorage.setItem('sourceParams', JSON.stringify(obj));
    }
}
export function getSourceParamsFromLocalStorage() {
    const params = localStorage.getItem('sourceParams');
    if (!params) return {};

    const {
        source, entryPoint, eventName, eventDate,
    } = JSON.parse(params);
    return {
        source: isValidSource(source) ? source : '',
        entryPoint: isValidEntryPoint(entryPoint) ? entryPoint : '',
        eventName,
        eventDate,
    };
}
export function clearSourceParams() {
    localStorage.removeItem('sourceParams');
}
